import React, { useEffect, useState } from "react";
import "./AppointmentScheduler.css";
import ContactsSelect from "../../components/ContactsSelect";
import { getBranch, getSpecialty, postBranch, postSpecialty } from "../../helpers/backend";
import AppointmentScheduler from "./AppointmentScheduler";
import ButtonVolver from "../../components/ButtonVolver"
import { Col } from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";

const AppointmentSetup = () => {
  const [branches, setBranches] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [showSpecialtyModal, setShowSpecialtyModal] = useState(false);
  const [newBranch, setNewBranch] = useState({});
  const [newSpecialty, setNewSpecialty] = useState({});
  const [setupData, setSetupData] = useState(null);

  const getBranchData = async () => {
    const response = await getBranch();
    setBranches(response.data.results);
  };

  const getSpecialtyData = async () => {
    const response = await getSpecialty();
    setSpecialties(response.data.results);
  };

  const handleSubmit = () => {
    if (!selectedBranch || !selectedSpecialty || !selectedContact) {
      alert("Por favor completa todos los campos.");
      return;
    }
    setSetupData({
      branch: selectedBranch,
      specialty: selectedSpecialty,
      contact: selectedContact,
    });
  };

  const handleCreateBranch = async () => {
    const response = await postBranch(newBranch);
    if (response) {
      setShowBranchModal(false);
      setNewBranch({});
      getBranchData();
    }
  };

  const handleCreateSpecialty = async () => {
    const response = await postSpecialty(newSpecialty);
    if (response) {
      setShowSpecialtyModal(false);
      setNewSpecialty({});
      getSpecialtyData();
    }
  };

  useEffect(() => {
    getBranchData();
    getSpecialtyData();
    // eslint-disable-next-line
  }, []);

  const theme = useSelector((state) => state.theme.theme) || "light";

  // Convertir branches a formato para Select
  const branchOptions = (branches || []).map((b) => ({
    value: b.id,
    label: b.nombre,
  }));

  // Convertir specialties a formato para Select
  const specialtyOptions = (specialties || []).map((s) => ({
    value: s.id,
    label: s.nombre,
  }));

  // Estilos para los Select
  const selectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: theme === "dark" ? "#242424" : "#fff",
      color: theme === "dark" ? "#c3cbe4" : "#000",
      borderColor: theme === "dark" ? "#3b3b3b" : "#d2d2d2",
      cursor: "pointer",
      fontSize: "0.9rem",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: theme === "dark" ? "#242424" : "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? theme === "dark"
          ? "#242424"
          : "#ccc"
        : isFocused
        ? theme === "dark"
          ? "#121212"
          : "#ddd"
        : "transparent",
      color: theme === "dark" ? "#c3cbe4" : "#000",
      padding: "10px",
      fontSize: "0.9rem",
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: theme === "dark" ? "#c3cbe4" : "#000",
    }),
  };

  return (
    <div className="page-content">
      {setupData ? (
        <AppointmentScheduler setupData={setupData} />
      ) : (
        <div className="modal-overlay-setup">
          <div className="modal-setup wide  card_container">
            <Col className="d-flex gap-3 mb-2 align-items-center">
              <ButtonVolver />
              <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
                Configura tu Cita
              </span>
            </Col>
            <div className="setup_field">
              <label style={{ color: theme === "dark" && "#c3cbe4" }}>
                Sede del hospital
              </label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto",
                  gap: ".5rem",
                  alignItems: "center",
                }}
              >
                <Select
                  options={branchOptions}
                  value={branchOptions.find(
                    (option) => option.value === selectedBranch?.id
                  )}
                  onChange={(selectedOption) =>
                    setSelectedBranch(
                      branches.find((b) => b.id === selectedOption.value)
                    )
                  }
                  placeholder="Selecciona una sede"
                  isMulti={false}
                  menuPosition="fixed"
                  styles={selectStyles}
                />
                <button
                  className="butt_add_"
                  onClick={() => setShowBranchModal(true)}
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div className="setup_field">
              <label style={{ color: theme === "dark" && "#c3cbe4" }}>
                Especialidad
              </label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto",
                  gap: ".5rem",
                  alignItems: "center",
                }}
              >
                <Select
                  options={specialtyOptions}
                  value={specialtyOptions.find(
                    (option) => option.value === selectedSpecialty?.id
                  )}
                  onChange={(selectedOption) =>
                    setSelectedSpecialty(
                      specialties.find((s) => s.id === selectedOption.value)
                    )
                  }
                  placeholder="Selecciona una especialidad"
                  isMulti={false}
                  menuPosition="fixed"
                  styles={selectStyles}
                />
                <button
                  className="butt_add_"
                  onClick={() => setShowSpecialtyModal(true)}
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div className="setup_field">
              <label style={{ color: theme === "dark" && "#c3cbe4" }}>
                Doctor
              </label>
              <ContactsSelect
                isMulti={false}
                value={selectedContact}
                placeholder="Seleccione o escriba un nombre"
                onContactSelect={(contactObj) => setSelectedContact(contactObj)}
              />
            </div>

            <button className="setup-button" onClick={handleSubmit}>
              Continuar
            </button>
          </div>

          {/* Modal Nueva Sede */}
          {showBranchModal && (
            <div className="modal-overlay-setup">
              <div className="modal-setup card_background">
                <h3>Nueva Sede</h3>
                <input
                  className="input_background"
                  placeholder="Nombre"
                  onChange={(e) =>
                    setNewBranch({ ...newBranch, nombre: e.target.value })
                  }
                />
                <input
                  className="input_background"
                  placeholder="Dirección"
                  onChange={(e) =>
                    setNewBranch({ ...newBranch, direccion: e.target.value })
                  }
                />
                <input
                  className="input_background"
                  placeholder="Teléfono"
                  onChange={(e) =>
                    setNewBranch({ ...newBranch, telefono: e.target.value })
                  }
                />
                <input
                  className="input_background"
                  placeholder="Email"
                  onChange={(e) =>
                    setNewBranch({ ...newBranch, email: e.target.value })
                  }
                />
                <textarea
                  className="input_background"
                  placeholder="Descripción"
                  onChange={(e) =>
                    setNewBranch({ ...newBranch, descripcion: e.target.value })
                  }
                />
                <div className="d-flex justify-content-center">
                  <button onClick={handleCreateBranch}>Guardar Sede</button>
                  <button onClick={() => setShowBranchModal(false)}>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal Nueva Especialidad */}
          {showSpecialtyModal && (
            <div className="modal-overlay-setup">
              <div className="modal-setup card_background">
                <h3>Nueva Especialidad</h3>
                <input
                  className="input_background"
                  placeholder="Nombre"
                  onChange={(e) =>
                    setNewSpecialty({ ...newSpecialty, nombre: e.target.value })
                  }
                />
                <Select
                  options={[
                    { value: "MEDICA", label: "Médica" },
                    { value: "QUIRURGICA", label: "Quirúrgica" },
                  ]}
                  onChange={(selectedOption) =>
                    setNewSpecialty({
                      ...newSpecialty,
                      tipo_servicio: selectedOption.value,
                    })
                  }
                  placeholder="Selecciona Tipo"
                  isMulti={false}
                  menuPosition="fixed"
                  styles={selectStyles}
                />
                <textarea
                  className="input_background mt-3"
                  placeholder="Descripción"
                  onChange={(e) =>
                    setNewSpecialty({
                      ...newSpecialty,
                      descripcion: e.target.value,
                    })
                  }
                />
                <div className="d-flex justify-content-center">
                  <button onClick={handleCreateSpecialty}>
                    Guardar Especialidad
                  </button>
                  <button onClick={() => setShowSpecialtyModal(false)}>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AppointmentSetup;